import { ActionTree, ActionContext } from "vuex";
import { State } from "./state";
import { Mutations } from "./mutations";
import { ActionTypes } from "./actions-types";
import { MutationTypes } from "./mutation-types";

type AugmentedActionContext = {
  commit<K extends keyof Mutations>(
    key: K,
    payload: Parameters<Mutations[K]>[1]
  ): ReturnType<Mutations[K]>;
} & Omit<ActionContext<State, State>, "commit">;

export interface Actions {
  [ActionTypes.GET_LOGIN_DIALOG_STATUS](
    { commit }: AugmentedActionContext,
    payload: number
  ): boolean;
}

export const actions: ActionTree<State, State> & Actions = {
  [ActionTypes.GET_LOGIN_DIALOG_STATUS]({ state }) {
    return state.isOpenLoginDialog;
  },

  [ActionTypes.GET_ADD_TASK_DIALOG_NAME]({ state }) {
    return state.addTaskDialogName;
  },

  [ActionTypes.GET_GOOGLE_TOKEN]({ state }) {
    return state.googleToken;
  },

  [ActionTypes.GET_COLUMNS]({ state }) {
    return state.columns;
  },

  [ActionTypes.GET_LABELS]({ state }) {
    return state.labels;
  },
};
